import { ICompanyDataModel } from '../../../data-models/company.data-model';
import { IMetricsDataModel } from '../../../data-models/metrics.data-model';
import { FMT } from '../../../util/formatter-service';
import { useCompanyMapLookup } from '../../../services/hooks/useSaveCompanyData';

export type MostRecentChartData = {
  formattedValue?: string | null;
  company: ICompanyDataModel;
  date: Date;
  dealLead?: string;
  round?: string | null;
  formattedValue2?: string | null;
};

export const useMostRecentRounds = (data: IMetricsDataModel[]): MostRecentChartData[] => {
  const getCompany = useCompanyMapLookup();
  const uniqueData = new Map<string, MostRecentChartData>();
  const dataCopy = [...(data ?? [])];

  const sortedData = dataCopy
    .reduce((res, metrics) => {
      const { companyId } = metrics;
      const company = getCompany(companyId);
      if (company && company.mostRecetRoundDate && metrics.normalizedMostRecentStage) {
        res.push({
          company,
          date: new Date(company.mostRecetRoundDate),
          round: metrics.normalizedMostRecentStage,
          formattedValue:
            company.lastPostMoney !== 0 ? FMT.format('currencyShort', company.lastPostMoney) : 'N/A',
        });
      }
      return res;
    }, [] as MostRecentChartData[])
    .sort(({ date: a }, { date: b }) => {
      return b.getTime() - a.getTime();
    });

  for (let i = 0; i < sortedData.length && uniqueData.size < 5; i++) {
    uniqueData.set(sortedData[i].company.name, sortedData[i]);
  }

  return Array.from(uniqueData.values());
};
